import { useDispatch } from 'react-redux';
import { useQuery } from '@zg-rentals/react-query5';

import ApplicationActions from '../../actions/ApplicationActions';

const useCopyApplicationLink = (listingAlias: string, applicationLink: string, useQueryOptions = {}) => {
  const dispatch = useDispatch();

  return useQuery({
    queryKey: ['handleApplicationInvitationLink', listingAlias, applicationLink],
    queryFn: () =>
      dispatch(
        ApplicationActions.copyApplicationLinkApi({
          listingAlias,
          applicationLink,
        }),
      ),
    ...useQueryOptions,
  });
};

export default useCopyApplicationLink;
